import React from 'react';

// Logo of the platform (public/logo.png, made from public/esante.png), on a white tile so that
// it stays readable on light and dark backgrounds.
const Logo = ({ size = 36, className = 'rounded-xl', title }) => (
  <span
    title={title}
    className={`flex flex-none items-center justify-center overflow-hidden bg-white ring-1 ring-black/[0.06] ${className}`}
    style={{ width: size, height: size }}
  >
    <img src="/logo.png" alt="" width={size} height={size} className="h-[84%] w-[84%] object-contain" />
  </span>
);

export default Logo;
